import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import { defaultInstance } from 'services'

import { responseSuccess, responseError } from 'utils/response'

const getStatuses = () => {
  return [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
  ]
}

const statuses = getStatuses()

const getStatusByValue = (value) => {
  return _.find(statuses, { value })
}

export const mapRiskMatrix = (item) => {
  return {
    ...item,
    key: uuidv4(),
    id: item?.risk_level_id,
    impact: item?.impact_level.report_hd_att_val_name,
    impact_score: item?.impact_level?.report_hd_att_val_score,
    likelihood: item?.likelihood_level.report_hd_att_val_name,
    likelihood_score: item?.likelihood_level?.report_hd_att_val_score,
    description: item?.risk_level_description,
    group: item.risk_level_group?.value_list_id,
    group_name: item.risk_level_group?.value_list_name,
    color: item?.risk_level_color_id,
    color_code: item?.risk_level_color?.value_list_name,
    color_name: item?.risk_level_color?.value_list_description,
    significant: item?.is_significant,
    is_active: item?.is_active,
    status: getStatusByValue(item?.is_active),
  }
}

export const getRiskMatrixApi = (impactId, { param, is_active }) => {
  const params = { param, is_active }
  const config = {
    method: 'get',
    url: `/api/v1/report_matrix_value/${impactId}`,
    params,
  }
  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0) {
        return responseSuccess({ data: _.map(res.data?.items, mapRiskMatrix) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      return responseError({ message: err.message })
    })
}

export const updateRiskMatrixApi = ({
  id,
  risk_level_group_id,
  risk_level_color_id,
  risk_level_description,
  is_active,
  is_significant,
}) => {
  const data = {
    risk_level_group_id,
    risk_level_color_id,
    risk_level_description,
    is_active,
    is_significant,
  }
  const config = {
    method: 'patch',
    url: `/api/v1/report_matrix_value/${id}`,
    data,
  }
  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({ message: err.response.data?.message })
      } else if (err.request) {
        console.log('err.request', err.request)
        return responseError({ message: 'API something went wrong' })
      }
      return responseError({ message: err.message })
    })
}
